/* ===== WA Faves – single, global wiring ===== */
(function(){
  if (window.WA_FAVES_WIRED) return; window.WA_FAVES_WIRED = true;

  /* 0) Config (set these if your templates don’t already) */
  window.WA_WISHLIST_ENDPOINT = window.WA_WISHLIST_ENDPOINT || 'https://wishlist-counter.wondersartistonetsy.workers.dev';
  window.WA_CUSTOMER_GID      = window.WA_CUSTOMER_GID || null;   // "gid://shopify/Customer/…"
  window.WA_LOGGED_IN         = !!window.WA_CUSTOMER_GID;

  /* helpers */
  const qsa    = (sel, root=document)=> Array.from(root.querySelectorAll(sel));
  const cssEsc = (s)=> window.CSS?.escape ? CSS.escape(String(s)) : String(s).replace(/"/g,'\\"');
  const safeNum = (v)=> {
    // be tolerant: accept 7 or "7"
    const n = (typeof v === 'number') ? v : parseInt((v ?? '').toString(),10);
    return Number.isFinite(n) ? n : null;
  };

  function ensureCountSpan(btn){
    let cnt = btn.querySelector('[data-like-count]');
    if (!cnt){
      cnt = document.createElement('span');
      cnt.className = 'wa-card-like-count';
      cnt.setAttribute('data-like-count', '');
      btn.appendChild(cnt);
    }
    return cnt;
  }

  function setCount(btn, n){
    const cnt = ensureCountSpan(btn);
    if (n == null) return;               // don’t overwrite with undefined
    const val = Math.max(0, n)|0;
    cnt.textContent = String(val);
    btn.setAttribute('data-like-count-value', String(val));
    if (val <= 0) cnt.setAttribute('aria-hidden','true'); else cnt.removeAttribute('aria-hidden');
  }

  function setState(btn, isOn){
    btn.classList.toggle('is-on', !!isOn);
    btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    btn.setAttribute('aria-label', isOn ? 'Remove from favorites' : 'Add to favorites');
  }

  async function fetchCountSingle(id){
    try{
      const url = `${window.WA_WISHLIST_ENDPOINT.replace(/\/$/,'')}/counts?ids=${encodeURIComponent(id)}`;
      const r   = await fetch(url, { method:'GET', cache:'no-store' });
      const j   = await r.json().catch(()=>({}));
      const map = (j && j.counts) ? j.counts : {};
      return safeNum(map[id]);
    }catch(_e){ return null; }
  }

  async function postToggle({btn, turningOn}){
    const productId = btn.getAttribute('data-product-gid');
    const customerId = window.WA_CUSTOMER_GID;
    if (!productId || !customerId) return { ok:false };

    const r = await fetch(window.WA_WISHLIST_ENDPOINT.replace(/\/$/,''), {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ action: turningOn ? 'add' : 'remove', productId, customerId })
    });
    const j = await r.json().catch(()=>({}));

    // Normalize what we return
    return {
      ok: !!(r.ok && j && (j.ok !== false)),
      isOn: !!j.isOn,
      count: safeNum(j.count)   // tolerate string or number
    };
  }

  /* 1) Delegate clicks for BOTH: cards + PDP button */
  document.addEventListener('click', async (e)=>{
    const btn =
      e.target.closest('[data-wa-card-fave][data-product-gid]') ||
      e.target.closest('.wa-fave-btn[data-product-gid]'); // PDP button, if you use it
    if (!btn) return;

    e.preventDefault(); e.stopPropagation();

    if (!window.WA_LOGGED_IN){
      // show your existing auth modal if present
      (window.WA_OPEN_AUTH && WA_OPEN_AUTH('register')) ||
      (window.WA_OPEN_LOGIN && WA_OPEN_LOGIN());
      return;
    }

    const turningOn = !btn.classList.contains('is-on');

    // optimistic heart only
    setState(btn, turningOn);

    btn.disabled = true;
    try{
      const { ok, isOn, count } = await postToggle({ btn, turningOn });

      if (ok){
        setState(btn, isOn);

        // 1st choice: use Worker’s count
        let next = safeNum(count);

        // fallback: immediately re-fetch live count for THIS product id
        if (next == null){
          const id = btn.getAttribute('data-product-gid');
          next = await fetchCountSingle(id);
        }

        // paint on: the clicked button, and any other buttons on the page for same product
        if (next != null){
          const idSel = `[data-product-gid="${cssEsc(btn.getAttribute('data-product-gid'))}"]`;
          qsa(idSel).forEach(el => setCount(el, next));
        }
      }else{
        // rollback the heart if server failed
        setState(btn, !turningOn);
      }
    }catch(_e){
      setState(btn, !turningOn);   // rollback on error
    }finally{
      btn.disabled = false;
    }
  }, true);

  /* 2) Hydrate counts for anything visible on the page */
  async function hydrateCounts(){
    try{
      const els = qsa('[data-product-gid]');
      if (!els.length) return;

      // make unique list of product GIDs
      const ids = [...new Set(els.map(el => el.getAttribute('data-product-gid')).filter(Boolean))];

      // small batches keep CF happy
      const batches = [];
      for (let i=0; i<ids.length; i+=60) batches.push(ids.slice(i, i+60));

      for (const batch of batches){
        const url = `${window.WA_WISHLIST_ENDPOINT.replace(/\/$/,'')}/counts?ids=${encodeURIComponent(batch.join(','))}`;
        const r = await fetch(url, { method:'GET', cache:'no-store' });
        const j = await r.json().catch(()=>({}));
        const map = j && j.counts ? j.counts : {};
        batch.forEach(id=>{
          const n = safeNum(map[id]);
          if (n == null) return;
          const sel = `[data-product-gid="${cssEsc(id)}"]`;
          qsa(sel).forEach(btn => setCount(btn, n));
        });
      }
    }catch(_e){}
  }

  /* 3) Optional: hydrate “is-on” for the current customer */
  async function hydrateStates(){
    try{
      if (!window.WA_LOGGED_IN) return;
      const els = qsa('[data-product-gid]');
      if (!els.length) return;

      const ids = [...new Set(els.map(el => el.getAttribute('data-product-gid')).filter(Boolean))];

      for (let i=0; i<ids.length; i+=60){
        const part = ids.slice(i,i+60);
        // NOTE: your Worker currently exposes /is (single). If you add a /status for batch,
        // switch this to that endpoint. For now we’ll do single GETs to be safe.
        await Promise.all(part.map(async (id)=>{
          try{
            const u = new URL(window.WA_WISHLIST_ENDPOINT.replace(/\/$/,'') + '/is');
            u.searchParams.set('cust', window.WA_CUSTOMER_GID);
            u.searchParams.set('prod', id);
            const r = await fetch(u, {cache:'no-store'});
            const j = await r.json().catch(()=>({}));
            const on = !!j.isOn;
            qsa(`[data-product-gid="${cssEsc(id)}"]`).forEach(btn => setState(btn, on));
          }catch(_e){}
        }));
      }
    }catch(_e){}
  }

  // Run once on load (cards, PDP, wishlist, collections — everywhere)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=>{ hydrateCounts(); hydrateStates(); });
  }else{
    hydrateCounts(); hydrateStates();
  }
})();
